// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".offer-answers-list .offer-answers-item{font-size:0.9em;border-top:1px solid #e0edff}.offer-answers-list .offer-answers-item .actions-answer{border-right:1px solid #e0edff}.offer-answers-list .offer-answers-item .actions-answer .comment{margin-top:1em}.offer-answers-list .offer-answers-item .btn:disabled{cursor:not-allowed}.offer-answers-list .offer-answers-item .badge{font-size:90%}\n", ""]);
// Exports
module.exports = exports;
